
import {ConnectionTracker} from './connection-tracker';
import {StationStateDtoMapper, IStationState, IStationStateDto} from './station-state-dto-mapper';
import {StationStateLogsDtoMapper, IStationStateLogsDto} from './station-state-logs-dto-mapper';

export class StationStateTracker {

    private alarmStateCallbacks: Array<((update: IStationState, initialState: boolean) => void)> = [];

    constructor(
        private connectionTracker: ConnectionTracker,
        private stationStateDtoMapper: StationStateDtoMapper,
        private stationStateLogsDtoMapper: StationStateLogsDtoMapper) {

        this.connectionTracker.registerHandler(
            'StationStateUpdate',
            dto => this.onAlarmStateUpdate(dto));

        // The initial state is read from the logs, so we register that handler as well
        this.connectionTracker.registerHandler(
            'StationStateLogs',
            dto => this.onAlarmStateLogs(dto));
    }

    private onAlarmStateUpdate(dto: IStationStateDto) {

        let alarmState = this.stationStateDtoMapper.mapDto(dto);

        this.alarmStateCallbacks.forEach(c => c(alarmState, false));
    }

    private onAlarmStateLogs(dto: IStationStateLogsDto) {

        let logs = this.stationStateLogsDtoMapper.mapDto(dto);

        let current = logs[0];

        this.alarmStateCallbacks.forEach(c => c(current.stationState, true));
    }

    public registerAlarmStateCallback(callback: ((update: IStationState, initialState: boolean) => void)) {
        this.alarmStateCallbacks.push(callback);
    }
}

